import useStorage, { read as storageRead, remove as storageRemove, write as storageWrite, } from './useStorage';
const options = { storage: 'localStorage' };
const useLocalStorage = (key, initial) => useStorage(key, initial, options);
export const write = storageWrite('localStorage');
export const get = storageRead('localStorage');
export const remove = storageRemove('localStorage');
export default useLocalStorage;
